import { fetchList, postPayload, mockDataGenerator } from '@bit/knotchinc.web-react-components.utils.fetch-actions';
import reports from 'api/reports.js';
import mockReportData from './mockReportData.json';

export const FETCH_REPORT = 'FETCH_REPORT';
export const FETCHED_REPORT = 'FETCHED_REPORT';

export const FETCH_REPORTS_LIST = 'FETCH_REPORTS_LIST';
export const FETCHED_REPORTS_LIST = 'FETCHED_REPORTS_LIST';
export const SET_REPORTS_LIST_FILTER = 'SET_REPORTS_LIST_FILTER';

export const SET_REPORT_REQUEST_KEY = 'SET_REPORT_REQUEST_KEY';

export const POST_REPORT_REQUEST = 'POST_REPORT_REQUEST';
export const POSTED_REPORT_REQUEST = 'POSTED_REPORT_REQUEST';

export const fetchReportsList = clear => (dispatch, getState) => {
  fetchList({
    clear,
    dispatch,
    getState,
    store: getState().Reports.reportsList,
    fetchingActionType: FETCH_REPORTS_LIST,
    fetchedActionType: FETCHED_REPORTS_LIST,
    apiCall: (filters) => reports.getReportsList(filters),
  });
};

export const fetchReportData = (id) => dispatch => {
  dispatch({ type: FETCH_REPORT });

  if (id === 'demo') {
    return dispatch({ type: FETCHED_REPORT,
      status: 'success',
      data: mockReportData,
      id,
    });
  }

  return reports.getReport(id)
    .end((err, response) => {
      if (err) {
        dispatch({ type: FETCHED_REPORT, status: 'error', data: {}, id });
      } else {
        dispatch({ type: FETCHED_REPORT, status: 'success', data: response.body, id });
      }
    });
};

export const submitReport = () => (dispatch, getState) => {
  const reportRequest = getState().ReportRequest.request;
  dispatch({ type: POST_REPORT_REQUEST, reportRequest });
  // console.log(reportRequest);
  setTimeout(() => dispatch({ type: POSTED_REPORT_REQUEST }), 500);
};

export const submitReport2 = () => (dispatch, getState) => {
  const reportRequest = getState().ReportRequest.request;

  return postPayload({
    dispatch,
    fetchingActionType: POST_REPORT_REQUEST,
    fetchedActionType: POSTED_REPORT_REQUEST,
    payload: reportRequest,
    apiCall: () => mockDataGenerator({}, 200),
  });
};
